import React from 'react';
import { Link } from '@mui/material';
import { candidateFilterSx } from 'modules/candidate-profile/styles/candidateFilterSx';

type CandidateFilterConnectorProps = {
  word: 'And' | 'Or';
  onClick: () => void;
};

export const CandidateFilterConnector: React.FC<
  CandidateFilterConnectorProps
> = ({ word, onClick }) => (
  <Link
    component="button"
    onClick={onClick}
    aria-label={
      word === 'And' ? 'Or these filters instead' : 'And these filters instead'
    }
    sx={candidateFilterSx.chipRailConnector}
  >
    {word}
  </Link>
);
